import { ADMIN_LOGIN, ADMIN_LOGOUT } from "../Types/types";

const initState = {
  adminToken: "",
  refreshToken: "",
  role: "",
  isAdmin: false,
};

const AdminReducer = (state = initState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN:
      return {
        ...state,
        adminToken: action.payload,
        refreshToken: action.refreshToken,
        role: action.role,
        isAdmin: true,
      };

    case ADMIN_LOGOUT:
      return {
        ...state,
        adminToken: "",
        refreshToken: "",
        role: "",
        isAdmin: false,
      };

    default:
      return state;
  }
};

export default AdminReducer;
